<template>
  <div id="term-import-history-list">
    <div :class="{
      'wrapper-table': true,
      'hidden': loadingTable
    }">
      <v-data-table
        ref="importHistoryTable"
        :headers="headers"
        :items="historyGetter.data"
        :must-sort="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        hide-actions
        :no-data-text="loadingTable ? '' : 'Não há dados a serem exibidos'"
        item-key
        loading-text="Carregando..."
      >
        <template slot="items" slot-scope="props">
          <td class="badges">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-on="on"
                  v-bind="attrs"
                  v-if="props.item.in_production === 1 && props.item.status === 'success'"
                  class="info prod"
                >prod</span>
              </template>
              <span>Em Produção</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-on="on"
                  v-bind="attrs"
                  v-if="props.item.is_schedule === 1"
                  class="info schedule"
                >agen</span>
              </template>
              <span>Agendado</span>
            </v-tooltip>
          </td>
          <td class="registration">{{ props.item.registration }}</td>
          <td class="created-at">{{ props.item.schedule_date | formatBRDateTimeSecs }}</td>
          <td class="type-import">{{ props.item.type_import_translated }}</td>
          <td class="segment">{{ props.item.segment_translated | formatSegment }}</td>
          <td class="status">{{ props.item.status_translated }}</td>
          <td class="actions">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <label v-on="on" v-bind="attrs"
                  @click="download(props.item.file_path, props.item.status)"
                  :class="{
                    'cursor-pointer': !isDownloadingGetter,
                    'cursor-wait': isDownloadingGetter,
                  }"
                >
                  <smart-icon :size="2" name="download" class="download" />
                </label>
              </template>
              <span>Download</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <label v-on="on" v-bind="attrs"
                  @click="cancel(props.item.id, props.item.status)"
                  :class="{
                    'cursor-pointer': !cancelDisabled(props.item.status),
                    'cursor-not-allowed': cancelDisabled(props.item.status),
                  }"
                >
                  <smart-icon :size="2" name="close" class="close" />
                </label>
            </template>
              <span>Cancelar</span>
            </v-tooltip>

            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <label v-on="on" v-bind="attrs" @click="view(props.item.id)" class="cursor-pointer">
                  <smart-icon :size="2" name="view" class="view" />
                </label>
            </template>
              <span>Visualizar</span>
            </v-tooltip> -->
          </td>
        </template>
      </v-data-table>

      <div v-if="loadingTable" class="loading-table text-center">
        <smart-skeleton-loading :height="5" :items="11" />
      </div>
    </div>
    <div class="flex justify-center">
      <v-pagination
        v-if="historyGetter.current_page"
        v-model="page"
        @input="changePage(page)"
        :length="Math.ceil(historyGetter.total/10)"
        :value="page"
        :total-visible="10"
        :disabled="loadingTable"
        circle
      />
    </div>

    <smart-modal
      v-if="modal"
      v-bind="modal"
      @close="modal = null"
      @return="modal.onConfirm"
      :loading-second-button="loadingTable"
      :closeOnEsc="true"
    >
      {{ modal.text }}
    </smart-modal>

    <smart-modal
      v-if="errorHandleGetter"
      v-bind="errorDownloadModal"
      @close="clearErrorHandle">
        {{ errorDownloadModal.text }}
    </smart-modal>
  </div>
</template>

<script>
import wait from '@/globalFunctions/wait';
import { mapGetters, mapActions } from 'vuex';
import { formatBRDateTimeSecs } from "utils/date";

export default {
  name: 'TermImportHistoryList',
  filters: {
    formatBRDateTimeSecs,
    formatSegment: function(value) {
      if (!value) {
        return '-';
      }

      return value.replace(/\s-\s/g, '/');
    }
  },
  components: {},
  props: {},
  data() {
    return {
      headers: [
        { text: '', value: 'badges', sortable: false },
        { text: 'Matrícula', value: 'registration', sortable: this.sortable },
        { text: 'Data da Importação', value: 'schedule_date', sortable: this.sortable },
        { text: 'Tipo de importação', value: 'type_import', sortable: this.sortable },
        { text: 'Local da carga', value: 'segment', sortable: this.sortable },
        { text: 'Status', value: 'status', sortable: this.sortable },
        { text: 'Ações', value: 'id', sortable: false },
      ],
      items: [],
      loadingTable: true,
      page: 1,
      filters: [],
      modal: null,
      sortBy: 'schedule_date',
      sortDesc: true,
      sortable: false,
    };
  },
  methods: {
    ...mapActions({
      fetchHistory: 'termImportHistory/fetchHistory',
      setFilters: 'termImportHistory/setFilters',
      cancelHistory: 'termImportHistory/cancelHistory',
      downloadFromAws: 'termDownload/downloadFromAws',
      clearErrorHandle: 'termDownload/clearErrorHandle',
    }),
    cancel(id, status) {
      if (this.cancelDisabled(status)) {
        return;
      }

      this.confirmModal(async () => {
        this.loadingTable = true;
        await this.cancelHistory(id).then(async () => {
          this.fetchHistory({ filters: this.filtersGetter, page: this.page });
          this.loadingTable = false;
          await wait(100);
          return this.successModal();
        })
        .catch(async err => {
          this.loadingTable = false;
          await wait(100);
          return this.errorModal(err.data.message);
        });
      });
    },
    cancelDisabled(status) {
      const ableTo = ['waiting', 'received'];

      return !ableTo.includes(status);
    },
    async download(fullPath, status) {
      if (this.isDownloadingGetter) {
        return;
      }

      await this.downloadFromAws(fullPath);
    },
    // },
    async changePage(page) {
      if (typeof page === 'undefined') {
        page = 1;
      }

      this.loadingTable = true;
      await this.fetchHistory({ filters: this.filtersGetter, page: page });
      this.loadingTable = false;
    },
    successModal() {
      this.modal = {
        type: 'success',
        title: 'Tudo certo!',
        text: 'Histórico de importação cancelado com sucesso!',
        icon: 'accepted',
        buttonText: 'OK',
        onConfirm: () => { this.modal = null; }
      };
    },
    errorModal(message) {
      this.modal = {
        type: 'danger',
        title: 'Ocorreu um erro inesperado!',
        icon: 'warning',
        buttonText: 'OK',
        text: 'detalhes: ' + JSON.stringify(message),
        onConfirm: () => { this.modal = null; }
      };
    }, 
    confirmModal(onConfirm) {
      this.modal = {
        type: 'warning',
        title: 'Atenção!',
        icon: 'warning',
        buttonText: 'Não',
        secondButton: 'Sim',
        text: 'Tem certeza que deseja cancelar esta importação?',
        onConfirm: async () => {
          if (typeof onConfirm === 'function') {
            await onConfirm();
          }
          this.modal = null;
        },
      };
    },
  },
  computed: {
    ...mapGetters({
      historyGetter: 'termImportHistory/historyGetter',
      filtersGetter: 'termImportHistory/filtersGetter',
      isDownloadingGetter: 'termDownload/isDownloadingGetter',
      errorHandleGetter: 'termDownload/errorHandleGetter',
    }),
    errorDownloadModal() {
      return {
        type: "warning",
        title: "Falha ao baixar o arquivo",
        icon: "warning",
        buttonText: "Ok",
        text: `${this.errorHandleGetter.message}`,
      };
    },
  },
  watch: {
    historyGetter(newHistory, oldHistory) {
      if (newHistory !== oldHistory) {
        this.page = newHistory.current_page;
      }
    }
  },

  async mounted() {
    this.loadingTable = true;
    this.setFilters({});
    await this.fetchHistory({ filters: this.filtersGetter, page: this.page });
    this.loadingTable = false;
    this.sortable = true;
  },
}
</script>

<style lang="scss">
#term-import-history-list {
  .wrapper-table {
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    margin: 10px auto;
    padding: 0;
    min-height: 540px;
    overflow-x: auto;
    position: relative;

    .v-table__overflow {
      border-radius: 8px;
      border: 1px solid $color-ui-gradient-gray!important;
      min-height: 537px;
      background: rgba(0,0,0,.02);
    }

    &.hidden {
      overflow: hidden;

      .v-table__overflow table tbody {
        opacity: 0;
      }
    }

    .v-table__overflow {
      border: none;
    }

    table.v-table {
      width: 1126px;

      .cursor-not-allowed svg.close {
        fill: $color-ui-gradient-gray;
        border-color: $color-ui-gradient-gray;
      }

      svg {
        padding: 0;
        height: 40px;
        width: 40px;
        display: inline-block;
        margin: 0 5px;

        &:hover {
          background: rgba(0,0,0,.05);
          border-radius: 100%;
        }

        &.close {
          padding: 0;
          border-radius: 100%;
          fill: $color-ui-danger;
          border: 3px solid $color-ui-danger;
        }

        &.download {
          fill: $color-ui-accent;
          box-sizing: content-box;
        }

        &.view {
          fill: $color-ui-accent;
          box-sizing: content-box;
        }

        thead {
          th.column.sortable.text-xs-left {
            font-size: 14px;
            font-weight: 500;
          }
        }
      }

      tbody tr:last-child {
        border-bottom: 1px solid rgba(0,0,0,.12);
      }

      thead, tbody {
        td.badges {
          span.info {
            color: white;
            padding: 2px 4px;
            border-radius: 5px;
            font-size: 11px;
            display: flex;
            width: 40px;
            margin-top: 2px;
            cursor: default;

            &.prod {
              background: $color-ui-accent;
            }

            &.schedule {
              background: $color-ui-orange;
            }
          }
        }
        td, th {
          &:first-child, &:not(:first-child) {
            padding: 0 5px;
          }

          &:first-child {
            padding-left: 15px;
          }

          &.actions {
            min-width: 100px;
          }
        }
      }
    }

    .theme--light.v-table th.column {
      font-size: 15px;
      font-weight: 500;
    }

    .loading-table {
      height: auto;
      min-height: 540px;
      width: 100%;
      display: table-cell;
      position: absolute;
      top: 0;
      left: 0;

      .skeleton-loading:first-child {
        opacity: 0;
      }
    }
  }
}

.v-tooltip__content {
  background: rgba(0,0,0,.8)!important;
  margin-top: -5px;
  font-size: 14px!important;
  padding: 10px 20px!important;
  box-shadow: 0 5px 5px rgba(0,0,0,.5)!important;
  border-radius: 5px;
  color: white;
  cursor: default;
  font-weight: 500;
}

.skeleton-loading.rounded.my-2 {
  width: calc(100% - 0.2rem);
  margin-left: 0.1rem;
}
</style>
